import { useVirtualizer } from '@tanstack/react-virtual';
import { RefObject } from 'react';

interface Props {
  count: number;
  cellHeight: number;
  parentRef: RefObject<HTMLElement | null>;
  overscan?: number;
}
export function useCustomVirtualizer({ count, cellHeight, parentRef, overscan = 20 }: Props) {
  const rowVirtualizer = useVirtualizer({
    count: count,
    estimateSize: () => cellHeight,
    overscan: overscan,
    scrollPaddingStart: cellHeight * 3,
    scrollPaddingEnd: cellHeight * 2,
    getScrollElement: () => parentRef.current,
  });

  const virtualItems = rowVirtualizer.getVirtualItems();
  const totalSize = rowVirtualizer.getTotalSize();
  const paddingTop = virtualItems.length > 0 ? virtualItems?.[0]?.start || 0 : 0;
  const paddingBottom = virtualItems.length > 0 ? totalSize - (virtualItems?.[virtualItems.length - 1]?.end || 0) : 0;

  const measureElement = rowVirtualizer.measureElement;

  return { virtualItems, totalSize, paddingTop, paddingBottom, measureElement };
}
